/* ============================================================
   MECHANICAL SOLUTIONS LLC — Theme JavaScript
   ============================================================ */

(function() {
  'use strict';

  /* ── HEADER: Sticky shadow on scroll ── */
  document.addEventListener('DOMContentLoaded', function() {
    var header = document.getElementById('ms-header');
    if (header) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 10) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }, { passive: true });
    }

    /* ── MOBILE MENU ── */
    var mobileMenuBtn = document.getElementById('ms-mobile-menu-btn');
    var mobileMenu = document.getElementById('ms-mobile-menu');
    var mobileMenuClose = document.getElementById('ms-mobile-menu-close');

    if (mobileMenuBtn && mobileMenu) {
      mobileMenuBtn.addEventListener('click', function() {
        mobileMenu.classList.add('open');
        document.body.style.overflow = 'hidden';
      });

      if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', function() {
          mobileMenu.classList.remove('open');
          document.body.style.overflow = '';
        });
      }

      mobileMenu.addEventListener('click', function(e) {
        if (e.target === mobileMenu) {
          mobileMenu.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    }

    /* ── FAQ ACCORDION ── */
    var faqBtns = document.querySelectorAll('.ms-faq-btn');
    faqBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var answer = btn.nextElementSibling;
        var icon = btn.querySelector('.ms-faq-icon');
        var isOpen = answer.classList.contains('open');

        // Close all others
        document.querySelectorAll('.ms-faq-answer').forEach(function(a) {
          a.classList.remove('open');
        });
        document.querySelectorAll('.ms-faq-icon').forEach(function(i) {
          i.classList.remove('open');
        });

        // Toggle current
        if (!isOpen) {
          answer.classList.add('open');
          if (icon) icon.classList.add('open');
        }
      });
    });

    /* ── PRODUCT PAGE: Image gallery ── */
    var mainImage = document.getElementById('ms-main-product-image');
    var thumbs = document.querySelectorAll('.ms-gallery__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var newSrc = thumb.dataset.src;
        if (mainImage && newSrc) {
          mainImage.src = newSrc;
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        }
      });
    });

    /* ── PRODUCT PAGE: Quantity stepper ── */
    var qtyInput = document.getElementById('ms-qty');
    var qtyMinus = document.getElementById('ms-qty-minus');
    var qtyPlus = document.getElementById('ms-qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }
  });

  /* ── VIDEO: Click-to-play ── */
  window.msPlayVideo = function(el) {
    var container = el instanceof HTMLElement ? el : document.getElementById('ms-video-container');
    if (!container) return;
    var videoUrl = container.dataset.videoUrl;
    var posterUrl = container.dataset.posterUrl;
    container.innerHTML = '<video src="' + videoUrl + '" poster="' + posterUrl + '" controls autoplay playsinline style="width:100%;height:100%;display:block;object-fit:cover;"></video>';
    container.style.cursor = 'default';
  };

  /* ── AJAX Add to Cart ── */
  window.msAddToCart = function(variantId, quantity) {
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      return fetch('/cart.js');
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      // Update all cart count badges
      var countEls = document.querySelectorAll('.ms-cart-count');
      countEls.forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      msShowNotification('Added to cart!');
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      msShowNotification('Error adding to cart');
    });
  };

  /* ── Add to Cart from product form ── */
  window.msAddToCartForm = function(e) {
    e.preventDefault();
    var form = e.target;
    var variantId = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value) : 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function() {
      window.location.href = '/cart';
    });
  };

  /* ── Notification toast ── */
  window.msShowNotification = function(message) {
    var notif = document.createElement('div');
    notif.className = 'ms-notification';
    notif.textContent = message;
    document.body.appendChild(notif);
    setTimeout(function() {
      if (notif.parentNode) notif.remove();
    }, 3000);
  };

})();
